import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Navbar from "../frontend/backend/navbar.js";
import Footer from "../frontend/backend/footer.js";
import Chatbox from "../frontend/backend/chatbox.js";
import HeaderRight from "../frontend/backend/header_right.js";
import LeftSidebar from "../frontend/backend/leftSidebar.js";
import ReactPaginate from "react-paginate";
import styled from "styled-components";
import apiConfig from '../apiConfig';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";

const Daily_deposit = () => {
  const [data, setData] = useState([]);
  const [limit, setLimit] = useState(10);
  const [pageCount, setPageCount] = useState(1);
  const currentPage = useRef(1);
  const [statusFilter, setStatusFilter] = useState("Paid");
  const [userId, setUserId] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  // ✅ Summary stats
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);         // all records total
  const [totalPaid, setTotalPaid] = useState(0);
  const [totalPending, setTotalPending] = useState(0);
  const [totalReject, setTotalReject] = useState(0);
  const [pageAmount, setPageAmount] = useState(0);         // current page total amount
  const [pageCount2, setPageCount2] = useState(0);         // current page record count

  useEffect(() => {
    const hash = window.location.hash;
    const queryString = hash.split("?")[1];
    if (queryString) {
      const params = new URLSearchParams(queryString);
      const id = params.get("user_id");
      if (id) setUserId(id);
    }
  }, []);

  const handlePageClick = (e) => {
    currentPage.current = e.selected + 1;
    getPaginatedUsers();
  };

  const changeLimit = () => {
    currentPage.current = 1;
    getPaginatedUsers();
  };

  const handleApprovePayment = async (depositId, status, event) => {
    event.preventDefault();
    try {
      const response = await axios.post(`${apiConfig.baseURL}/api/agent/user_withdraw_update`, {
        depositId, status
      });
      if (response.status === 200) {
        alert(response.data.message);
        getPaginatedUsers();
      } else {
        alert(`Failed: ${response.data.message}`);
      }
    } catch (error) {
      alert('Error: ' + error.message);
    }
  };

  useEffect(() => {
    if (userId) getPaginatedUsers();
  }, [limit, startDate, endDate, statusFilter, userId]);

  const getPaginatedUsers = async () => {
    const formattedStartDate = startDate ? startDate.toISOString() : "";
    const formattedEndDate = endDate ? endDate.toISOString() : "";
    try {
      const response = await axios.get(`${apiConfig.baseURL}/api/agent/daily_withdraw`, {
        params: {
          page: currentPage.current,
          limit: limit,
          status: statusFilter === 'all' ? undefined : statusFilter,
          startDate: formattedStartDate,
          user_id: userId,
          endDate: formattedEndDate
        }
      });

      if (response.status === 200) {
        const res = response.data;
        setPageCount(res.pageCount);
        setTotalAmount(res.totalAmount || 0);
        setTotalCount(res.totalCount || 0);
        setTotalPaid(res.totalPaid || 0);
        setTotalPending(res.totalPending || 0);
        setTotalReject(res.totalReject || 0);

        const sortedData = res.result.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        setData(sortedData);

        // ✅ Page-level summary (calculated from current page data)
        const pAmt = sortedData.reduce((sum, w) => sum + (parseFloat(w.withdraw_amount_in_bdt) || 0), 0);
        setPageAmount(pAmt);
        setPageCount2(sortedData.length);
      }
    } catch (error) {
      alert('Error fetching data: ' + error.message);
    }
  };

  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    const options = { hour: 'numeric', minute: 'numeric', hour12: true };
    const timeString = date.toLocaleString('en-US', options);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2);
    return `${timeString.toLowerCase()} ${day}.${month}.${year}`;
  };

  const MyPaginate = styled(ReactPaginate).attrs({ activeClassName: "active" })`
    margin-bottom: 2rem;
    display: flex;
    flex-direction: row;
    justify-content: center;
    list-style-type: none;
    padding: 0 2rem;
    li a {
      border-radius: 7px;
      padding: 0.1rem 1rem;
      border: gray 1px solid;
      cursor: pointer;
      margin: 0 5px;
    }
    li.active a { background-color: #0366d6; color: white; }
    li.disabled a { color: grey; background-color: #26B19B !important; }
  `;

  return (
    <>
      <Navbar />
      <Chatbox />
      <HeaderRight />
      <LeftSidebar />

      <div className="content-body">
        <div className="container-fluid">
          <div className="col-lg-12">

            {/* ✅ Summary Cards */}
            <div className="row mb-3">
               <div className="col-6 col-md-2">
                <div className="card text-center py-2 px-1" style={{ borderLeft: '4px solid #007bff' }}>
                  <small className="text-muted">This Page</small>
                  <h6 className="mb-0 fw-bold text-primary">৳ {Number(pageAmount).toLocaleString()}</h6>
                </div>
              </div>
              <div className="col-6 col-md-2">
                <div className="card text-center py-2 px-1" style={{ borderLeft: '4px solid #6c757d' }}>
                  <small className="text-muted">Total Records</small>
                  <h6 className="mb-0 fw-bold">{totalCount}</h6>
                </div>
              </div>
              <div className="col-6 col-md-2">
                <div className="card text-center py-2 px-1" style={{ borderLeft: '4px solid #28a745' }}>
                  <small className="text-muted">Paid</small>
                  <h6 className="mb-0 fw-bold text-success">{totalPaid}</h6>
                </div>
              </div>
              <div className="col-6 col-md-2">
                <div className="card text-center py-2 px-1" style={{ borderLeft: '4px solid #ffc107' }}>
                  <small className="text-muted">Pending</small>
                  <h6 className="mb-0 fw-bold text-warning">{totalPending}</h6>
                </div>
              </div>
              <div className="col-6 col-md-2">
                <div className="card text-center py-2 px-1" style={{ borderLeft: '4px solid #dc3545' }}>
                  <small className="text-muted">Rejected</small>
                  <h6 className="mb-0 fw-bold text-danger">{totalReject}</h6>
                </div>
              </div>
             
            </div>

            <div className="card">
              <h4 className="card-title px-3 pt-3">Daily Withdraw Report</h4>
              <div className="card-header">
                <div className="d-flex align-items-center flex-wrap gap-2">
                  <DatePicker
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    selectsStart
                    startDate={startDate}
                    endDate={endDate}
                    placeholderText="Start Date"
                    className="form-control"
                    dateFormat="dd/MM/yyyy"
                  />
                  <DatePicker
                    selected={endDate}
                    onChange={(date) => setEndDate(date)}
                    selectsEnd
                    startDate={startDate}
                    endDate={endDate}
                    minDate={startDate}
                    placeholderText="End Date"
                    className="form-control"
                    dateFormat="dd/MM/yyyy"
                  />
                  <select className="form-control w-auto" value={limit} onChange={(e) => { setLimit(e.target.value); changeLimit(); }}>
                    <option value="10">10</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  <select className="form-control w-auto" value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
                    <option value="all">All Status</option>
                    <option value="Pending">Pending</option>
                    <option value="Paid">Paid</option>
                    <option value="Reject">Reject</option>
                  </select>
                </div>
              </div>

              <div className="card-body">
                {/* ✅ Page Summary Bar */}
                <div className="d-flex justify-content-between align-items-center mb-2 px-1">
                  <small className="text-muted">
                    Showing <strong>{pageCount2}</strong> records on this page
                    &nbsp;|&nbsp; Page total: <strong className="text-primary">৳ {Number(pageAmount).toLocaleString()}</strong>
                    &nbsp;|&nbsp; Page <strong>{currentPage.current}</strong> of <strong>{pageCount}</strong>
                  </small>
                  <small className="text-muted">
                    Filter: <span className="badge bg-secondary">{statusFilter === 'all' ? 'All' : statusFilter}</span>
                  </small>
                </div>

                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th className="text-nowrap">User ID</th>
                        <th className="text-nowrap">Withdraw No</th>
                        <th className="text-nowrap">Agent ID</th>
                        <th className="text-nowrap">Amount</th>
                        <th className="text-nowrap">Method</th>
                        <th className="text-nowrap">Date</th>
                        <th className="text-nowrap">Status</th>
                        <th className="text-nowrap">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.length === 0 ? (
                        <tr>
                          <td colSpan="9" className="text-center text-muted py-4">No records found</td>
                        </tr>
                      ) : (
                        data.map((withdraw, index) => (
                          <tr key={index}>
                            <td>{(currentPage.current - 1) * limit + index + 1}</td>
                            <td className="text-nowrap">{withdraw.user_id}</td>
                            <td className="text-nowrap">{withdraw.sender_number}</td>
                            <td className="text-nowrap">{withdraw.agent_id}</td>
                            <td className="text-nowrap fw-bold">৳ {Number(withdraw.withdraw_amount_in_bdt).toLocaleString()}</td>
                            <td className="text-nowrap">{withdraw.selected_method}</td>
                            <td className="text-nowrap">{formatDate(withdraw.createdAt)}</td>
                            <td>
                              <span className={`badge ${withdraw.status === 'Paid' ? 'bg-success' : withdraw.status === 'Pending' ? 'bg-warning text-dark' : 'bg-danger'}`}>
                                {withdraw.status}
                              </span>
                            </td>
                            <td>
                              <div className="d-flex">
                                <button
                                  type="button"
                                  disabled={withdraw.status !== 'Pending'}
                                  className="btn btn-success shadow btn-xs sharp me-1"
                                  onClick={(e) => handleApprovePayment(withdraw._id, 'Paid', e)}
                                  title="Approve"
                                >
                                  <i className="fa fa-check"></i>
                                </button>
                                <button
                                  type="button"
                                  disabled={withdraw.status !== 'Pending'}
                                  className="btn btn-danger shadow btn-xs sharp me-1"
                                  onClick={(e) => handleApprovePayment(withdraw._id, 'Reject', e)}
                                  title="Reject"
                                >
                                  <i className="fa fa-times"></i>
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>

                    {/* ✅ Table Footer Summary */}
                    {data.length > 0 && (
                      <tfoot>
                        <tr className="table-light fw-bold">
                          <td colSpan="4" className="text-end">Page Total:</td>
                          <td>৳ {Number(pageAmount).toLocaleString()}</td>
                          <td colSpan="4"></td>
                        </tr>
                      </tfoot>
                    )}
                  </table>

                  <MyPaginate
                    breakLabel="..."
                    nextLabel=">"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={5}
                    pageCount={pageCount}
                    previousLabel="<"
                    marginPagesDisplayed={2}
                    containerClassName="pagination justify-content-center"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    activeClassName="active"
                    forcePage={currentPage.current - 1}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Daily_deposit;